import React, { Component } from "react";
import ConfirmationModal from "./ConfirmationModal";
import PropTypes from "prop-types";

class DeleteRoleModal extends Component {
  static propTypes = {
    onConfirmDelete: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ConfirmationModal
        actionDescription="Delete"
        buttonColor="grey"
        onConfirm={this.props.onConfirmDelete}
        menuTrigger={this.props.menuTrigger}
        icon="trash"
        warning
      >
        <p>Are you sure you want to delete this Role?</p>
      </ConfirmationModal>
    );
  }
}

export default DeleteRoleModal;
